import React, {useContext, useEffect, useState} from 'react';

import {makeStyles} from "@material-ui/core/styles";
import {useParams} from "react-router-dom";
import {getData} from "../utils/apiUtils";
import { getCurrentYear } from '../utils/dateUtils';
import {ErrorContext} from '../utils/constants';
import EnhancedTable from "../components/EnhancedTable";

const useStyles = makeStyles(() => ({
  h1: {
    paddingTop: '10%',
    fontWeight: 500,
    fontSize: '56px',
    lineHeight: '66px',
  },
  explaination: {
    fontSize: '30px',
  },
  btnClass: {
    marginTop: '8%',
    fontSize: '20px',
    padding: '20px 15px'
  },
}));

const resultsHeadCells = [
  { id: 'initiative_name', numeric: false, disablePadding: false, label: 'Initiative Name' },
  { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
  { id: 'max_date', numeric: false, disablePadding: true, label: 'Due Date', format: 'date' },
  { id: 'budget_impact', numeric: false, disablePadding: true, label: `Net Cash in ${getCurrentYear()}` },
];

export default function SearchPage() {
  const classes = useStyles();
  const { triggerError } = useContext(ErrorContext);
  const params = useParams();

  const [ searchResults, setSearchResults ] = useState([]);

  useEffect(() => {
    document.title = 'Rise by TransAlta Search';
  }, []);

  useEffect(() => {
    const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to get the search results. Please try again.',
      onRetry: () => window.location.reload(),
    });

    getData(`/dashboards/search/${params.searchTerm}`, setSearchResults, onError);
  }, [params.searchTerm, triggerError]);

  return (
    <main>
      <h1 className={classes.h1}>Search Results for "{params.searchTerm}"</h1>


      <EnhancedTable id='e012c764-6a9c-476b-b4d1-db7f19d4de57'
                     headCells={resultsHeadCells}
                     rows={searchResults}
                     clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
    </main>
  );
}
